/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Calendar_SyncInputs */

const en_svchip_calendar_sync = /** @type {(inputs: Svchip_Calendar_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendar sync`)
};

const ar_svchip_calendar_sync = /** @type {(inputs: Svchip_Calendar_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مزامنة التقويم`)
};

const bn_svchip_calendar_sync = /** @type {(inputs: Svchip_Calendar_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্যালেন্ডার সিঙ্ক`)
};

const de_svchip_calendar_sync = /** @type {(inputs: Svchip_Calendar_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalendersynchronisation`)
};

const es_svchip_calendar_sync = /** @type {(inputs: Svchip_Calendar_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronización de calendario`)
};

const fr_svchip_calendar_sync = /** @type {(inputs: Svchip_Calendar_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisation du calendrier`)
};

const pt_svchip_calendar_sync = /** @type {(inputs: Svchip_Calendar_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronização de calendário`)
};

const zh_svchip_calendar_sync = /** @type {(inputs: Svchip_Calendar_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日历同步`)
};

const tr_svchip_calendar_sync = /** @type {(inputs: Svchip_Calendar_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takvim senkronu`)
};

const ru_svchip_calendar_sync = /** @type {(inputs: Svchip_Calendar_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Синхронизация календаря`)
};

const pl_svchip_calendar_sync = /** @type {(inputs: Svchip_Calendar_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronizacja kalendarza`)
};

/**
* | output |
* | --- |
* | "Calendar sync" |
*
* @param {Svchip_Calendar_SyncInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_calendar_sync = /** @type {((inputs?: Svchip_Calendar_SyncInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Calendar_SyncInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_calendar_sync(inputs)
	if (locale === "bn") return bn_svchip_calendar_sync(inputs)
	if (locale === "de") return de_svchip_calendar_sync(inputs)
	if (locale === "es") return es_svchip_calendar_sync(inputs)
	if (locale === "fr") return fr_svchip_calendar_sync(inputs)
	if (locale === "pt") return pt_svchip_calendar_sync(inputs)
	if (locale === "zh") return zh_svchip_calendar_sync(inputs)
	if (locale === "tr") return tr_svchip_calendar_sync(inputs)
	if (locale === "ru") return ru_svchip_calendar_sync(inputs)
	if (locale === "pl") return pl_svchip_calendar_sync(inputs)
	return en_svchip_calendar_sync(inputs)
});